<template>
  <div class="lh-15 c-666">
    <ProductBanner
      is-fixed
      is-scroll
      :banner-img="bannerImg"
      :product-name="$t('common.productName.o1')"
      :product-img-style="{ backgroundImage: `url(${bannerProductImg})` }"
      :main-title="'FJD TRION O1'"
      :sub-title="'AerialMapper'"
      :slogan="'A New Way to Aerial-map the World'"
    >
    </ProductBanner>
    <div class="content p-r z-3 bgc-fff">
      <NavAnchor :product-name="$t('common.productName.o1')" :spec-url="'/product/aerial-mapper-specs'" />
      <IconWrap :icon-wrap-data="iconWrapData" id="overview" />
      <videoWrap class="area-2" :video-index="1" :video-info="videoInfo" :custom-style="{ width: '12rem' }" />
      <!-- 轮播 -->
      <VerticalCarousel
        carousel-h3="Application Scenarios"
        carousel-desc="Trion O1 makes urban planning, surveying, and mapping more efficient."
        class="area3"
        :swiper-option="area3SwiperOption"
        :swiper-data="swiper3Data"
      />
      <videoWrap :video-index="2" :video-info="area4VideoInfo" :custom-style="{ width: '12rem' }" />
      <videoWrap
        id="features"
        :video-index="3"
        video-class="d-f jc-sb fd-r area5-video-wrap"
        :video-info="area5VideoInfo"
        :custom-style="{ width: '12rem' }"
        class="area5"
      >
        <ul class="d-f jc-sa fd-c c-333 fw-500 fs-24 area-5-ul">
          <li class="li-item">
            1 frame <br class="in-pc" />
            per 0.5 seconds
          </li>
          <li class="li-item">
            150MP nadir <br class="in-pc" />
            RGB camera *1
          </li>
          <li class="li-item">
            150MP oblique <br class="in-pc" />
            RGB cameras *4
          </li>
        </ul>
      </videoWrap>
      <videoWrap class="area-6" :video-index="4" :video-info="area6VideoInfo" :custom-style="{ width: '12rem' }">
        <ul class="d-f jc-sb fs-24 c-333 fw-500 mt-32">
          <li class="area6-li">650km/h @5cm GSD & 80% forward overlap</li>
          <li class="area6-li">275km/h@2cm GSD & 80% forward overlap</li>
        </ul>
      </videoWrap>
      <videoWrap :video-index="5" class="area-7" :video-info="area7VideoInfo" :custom-style="{ width: '12rem' }" />
      <section class="area-8 pt-160">
        <div class="bgc-fafafa">
          <div class="w-12r m-a">
            <h2 class="ta-c c-333 fs-48 mb-24">Multi-platform Compatibility</h2>
            <div class="desc ta-c">
              A single person can handle the camera pod using the specifically designed pod lifter.
            </div>
            <div class="area-8-tab bgc-000 m-a p-r">
              <span class="tab-item1" @click="clickHelicopter" :class="isActiveHelicopter ? 'current' : ''"></span>
              <span class="tab-item2" @click="clickAircraft" :class="isActiveAircraft ? 'current' : ''"></span>
            </div>
            <div class="tab-desc ta-c fs-24 c-333 fw-500">
              <span>{{ isActiveHelicopter ? 'Separated Mode' : 'Integrated Mode' }}</span>
              <!-- <span class="d-n"></span> -->
            </div>
            <div class="tab-content">
              <div class="tab-image-box m-a" v-if="isActiveHelicopter">
                <img
                  class="lazy-image"
                  v-lazy="require('@/assets/images/aerialmapper/area-8-1.jpg')"
                  width="100%"
                  height="100%"
                  alt="Integrated Mode"
                />
              </div>
              <div class="tab-image-box m-a" v-if="isActiveAircraft">
                <img
                  class="lazy-image"
                  v-lazy="require('@/assets/images/aerialmapper/area-8-2.jpg')"
                  width="100%"
                  height="100%"
                  alt="Separated Mode"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="area-9">
        <div class="w-12r m-a pt-160">
          <h2 class="ta-c c-333 fs-48">Your Brilliant Assistant</h2>
          <div class="desc ta-c mb-32"></div>
          <div class="area-9-swiper-in-h5 p-r">
            <div class="pagination-in-h5 p-a w-100p ta-c"></div>
            <div class="swiper-wrapper">
              <div class="area-9-mod swiper-slide mb-24 d-f bgc-FAFAFA">
                <div class="img-box">
                  <img
                    src="@/assets/images/aerialmapper/area-9-2.jpg"
                    width="100%"
                    height="100%"
                    alt="FJD Pilot - flight control and navigation"
                  />
                </div>
                <div class="text-box">
                  <h3 class="fs-24 c-333 fw-500">FJD Pilot - flight control and navigation</h3>
                  <div>
                    FJD Pilot uses FJD Plan data to manage and guide the precise execution of aero-photography flight.
                  </div>
                  <ul>
                    <li><span>Show rulers of flight lines</span></li>
                    <li><span>Timed interval exposure control</span></li>
                    <li><span>Display the actual exposure position</span></li>
                  </ul>
                </div>
              </div>
              <div class="area-9-mod swiper-slide mb-24 d-f bgc-FAFAFA">
                <div class="img-box">
                  <img
                    src="@/assets/images/aerialmapper/area-9-1.jpg"
                    width="100%"
                    height="100%"
                    alt="FJD Capture - camera control"
                  />
                </div>
                <div class="text-box">
                  <h3 class="fs-24 c-333 fw-500">FJD Capture - camera control</h3>
                  <div>
                    FJD Capture is a software that provides real-time operation data of cameras installed on the FJD
                    Trion O1.
                  </div>
                  <ul>
                    <li><span>Set the exposure parameters </span></li>
                    <li><span>Set the path of stored photos</span></li>
                    <li>
                      <span
                        >Manage the photo files and display <br class="in-pc" />
                        <i class="in-pc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i>the photo thumbnail</span
                      >
                    </li>
                    <li><span>Display available storage capacity</span></li>
                  </ul>
                </div>
              </div>
              <div class="area-9-mod swiper-slide d-f bgc-FAFAFA">
                <div class="img-box">
                  <img
                    src="@/assets/images/aerialmapper/area-9-3.jpg"
                    width="100%"
                    height="100%"
                    alt="FJD Plan - flight plan design"
                  />
                </div>
                <div class="text-box">
                  <h3 class="fs-24 c-333 fw-500">FJD Plan - flight plan design</h3>
                  <div>With multiple control functions , FJD Plan allows you to easily generate flight plans.</div>
                  <ul>
                    <li><span>Define the area of survey</span></li>
                    <li><span>Generate the flight lines</span></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  // import { gsap } from 'gsap'
  // import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'
  import bannerImg from '@/assets/images/aerialmapper/banner-bg.jpg'
  import bannerProductImg from '@/assets/images/aerialmapper/banner-product.png'
  // backgroundImage
  import ProductBanner from '@/components/ProductBanner'
  import NavAnchor from '@/components/NavAnchor'
  import IconWrap from '@/components/IconWrap'
  import videoWrap from '@/components/videoWrap'
  import VerticalCarousel from '@/components/Carousel/VerticalCarousel'
  // import Application from '@/components/Application'
  // import CustomerCard from '@/components/CustomerCard'
  // import BlogCard from '@/components/BlogCard'
  import bannerScroll from '@/mixins/bannerScroll.js'
  const area3TabItem = [
    '<h3 class="area3-tab-h3">Urban Planning</h3><div class="tab-desc">3D city modellng</div><div class="tab-desc">Oil and gas pipeline planning</div>',
    '<h3 class="area3-tab-h3">Surveying and Mapping</h3><div class="tab-desc">2D mapping</div><div class="tab-desc">DSM & DTM</div><div  class="tab-desc">Forestry surveying</div>'
  ]
  export default {
    components: {
      ProductBanner,
      NavAnchor,
      IconWrap,
      videoWrap,
      VerticalCarousel
      // Application,
      // CustomerCard,
      // BlogCard
    },
    mixins: [bannerScroll],
    data() {
      const vm = this
      return {
        bannerImg,
        bannerProductImg,
        iconWrapData: [
          {
            icon: 'mp-resolution',
            vHtml: '150MP resolution <br/>per camera'
          },
          {
            icon: 'x-focal',
            vHtml: '1.8X focal length<br/> ratio(Oblique-Nadir)'
          },
          {
            icon: 'fps-capture',
            vHtml: '2 fps <br/> capture rate'
          },

          {
            icon: 'up-to-speed',
            vHtml: 'up to 1/2500s <br/> shutter speed'
          },
          {
            icon: 'gsd-forward',
            vHtml: '650km/h @5cm GSD  <br/>  80% forward overlap'
          },
          {
            icon: 'ssd',
            vHtml: ' 5*2TB SSD  <br/> mass memory'
          },
          {
            icon: 'multi-platform',
            vHtml: 'Multi-platform   <br/> Compatibility'
          },
          {
            icon: 'smart-cooling',
            vHtml: 'smart cooling  <br/>system'
          }
        ],
        videoInfo: {
          h2: 'A New Way to Aerial-map the World',
          desc: "FJD Trion O1 is a large-format aerial solution with extraordinary capturing performance and operational efficiency. Carrying four oblique RGB cameras and one nadir camera, 150 MP each, O1 captures photogrammetric images of superior quality, resolution, and clarity. It is by far one of FJD's most efficient all-in-one solutions for wide-area mapping and 3D city modeling.",
          poster:
            'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/0f2058ed387702306442842219/snapshotByTimeOffset/snapshotByTimeOffset_10_1.jpg',
          src: 'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/0f2058ed387702306442842219/AcZlYN6XzEgA.mp4'
        },
        area3SwiperOption: {
          el: '',
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'fade',
          // autoplay: { delay: 3000 },
          pagination: {
            el: ' .vertical-swiper-style .vertical-swiper-pagination ul',
            clickable: true,
            renderBullet(index, className) {
              return (
                '<li class="area3-tab ' +
                className +
                '"><div class="pagination-item">' +
                vm.$t(area3TabItem[index]) +
                '</div></li>'
              )
            }
          }
        },
        swiper3Data: [
          {
            imgSrc: require('@/assets/images/aerialmapper/area-3-1.jpg')
          },
          {
            imgSrc: require('@/assets/images/aerialmapper/area-3-2.jpg')
          }
        ],
        area4VideoInfo: {
          h2: 'O1 Flexing Its Muscle',
          desc: 'An O1 case shot at Zhangjiajie, the filming location of Avatar by James Cameron.',
          poster:
            'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/76b5521a387702307077168991/sampleSnapshot/sampleSnapshot_10_0.jpg',
          src: 'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/caadd67c387702307078466397/tUQEZpp6riYA.mp4'
        },
        area5VideoInfo: {
          h2: 'Top-level Image with High Efficiency',
          desc: 'Collect 1.5 billion geospatial pixels every second.',
          poster:
            'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/ff26d56e387702306442192960/sampleSnapshot/sampleSnapshot_10_0.jpg',
          src: 'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/8802a68b387702307050365860/WLeRSHkItasA.mp4'
        },
        area6VideoInfo: {
          h2: 'Efficient Collection',
          desc: 'Covers a wider area and adapts to faster speed.',
          poster: require('@/assets/images/aerialmapper/area-6.jpg'),
          isImg: true
        },
        area7VideoInfo: {
          h2: 'Outstanding Capturing Lens Configuration',
          desc: '1:1.8 Oblique-Nadir focal length ratio.',
          poster:
            'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/ff275490387702306442193628/sampleSnapshot/sampleSnapshot_10_0.jpg',
          src: 'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/8802a24c387702307050365762/cjrT4jdeDzAA.mp4'
        },
        isActiveHelicopter: true,
        isActiveAircraft: false
      }
    },
    head() {
      return {
        title: 'Trion O1 AerialMapper– FJDynamics',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Trion O1 AerialMappe, FJDynamics, FJD '
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'A large-format aerial solution with both nadir camera and oblique camera，150MP each，which is widely used in wide-area mapping and 3D city model'
          }
        ]
      }
    },
    created() {},
    mounted() {},
    methods: {
      clickHelicopter() {
        this.isActiveHelicopter = true
        this.isActiveAircraft = false
      },
      clickAircraft() {
        this.isActiveHelicopter = false
        this.isActiveAircraft = true
      }
    }
  }
</script>

<style scoped lang="scss">
  .fs-24 {
    font-size: 0.24rem;
  }
  .content {
    margin-top: 8.76rem;
  }
  .ul-pagination .area3-tab {
  }

  :deep(.banner-product-img) {
    width: 2.41rem;
    height: 2.95rem;
    top: 4.83rem;
    right: 1.8rem;
  }

  :deep(.area3 .vertical-swiper-style .vertical-swiper-pagination ul li) {
    height: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // transition: all transition;
    transition: transform 0.2s;
  }

  :deep(.area3 .vertical-swiper-style .swiper-pagination-bullet-active::before) {
    height: 50%;
  }
  :deep(.swiper-pagination-bullet .tab-desc) {
    color: #666;
    font-weight: 400;
    font-size: 0.2rem;
    position: relative;
    padding-left: 0.18rem;
    margin-bottom: 0.04rem;
    line-height: 1.5 !important;
    transition: transform 0.2s;
  }
  :deep(.swiper-pagination-bullet-active .tab-desc) {
    color: #333;
  }
  :deep(.swiper-pagination-bullet .area3-tab-h3) {
    transition: transform 0.2s;
    font-weight: 500;
    margin-bottom: 0.16rem;
    font-size: 0.28rem;
    color: #666;
  }

  :deep(.swiper-pagination-bullet-active .area3-tab-h3) {
    color: #333;
  }

  // :deep(.tab-desc::before) {
  //   display: inline-block;
  //   position: absolute;
  //   top: 50%;
  //   left: 0;
  //   transform: translateY(-50%);
  //   content: '';
  //   width: 5px;
  //   height: 5px;
  //   border-radius: 5px;
  //   background-color: #999;
  // }
  :deep(.area5-video-wrap .video-box) {
    width: 9.72rem;
    height: 5.47rem;
  }
  /* area-5 */
  .area-5 .img-box {
    width: 9.72rem;
    height: 5.47rem;
  }
  // .area-5-ul {
  //   padding: 0.47rem 0;
  // }
  .li-item {
    padding-bottom: 0.16rem;
    width: 1.91rem;
    border-bottom: 1px solid #333;
    white-space: nowrap;
    // flex: 1;
  }
  // area-6
  .area-6 .img-box {
    height: 100%;
    width: 100%;
  }
  :deep(.video-wrap .video-box) {
    height: 100%;
  }
  :deep(.video-wrap .img-box) {
    height: 6.75rem;
  }
  .area-6 ul {
    padding: 0 0.52rem;
  }
  .area6-li {
    list-style-type: square;
    font-weight: 500;
    font-size: 0.24rem;
  }
  // area-8
  .area-8-tab {
    width: 180px;
    height: 48px;
    border-radius: 24px;
  }
  .area-8-tab .tab-item1 {
    left: 2px;
  }
  .area-8-tab span {
    display: block;
    cursor: pointer;
    position: absolute;
    z-index: 3;
    width: 90px;
    height: 44px;
    top: 2px;
    border-radius: 22px;
  }
  .area-8-tab .tab-item1.current,
  .area-8-tab .tab-item2.current {
    background-color: #fff;
  }
  .area-8-tab .tab-item2 {
    right: 2px;
  }
  .area-8 .desc {
    margin-bottom: 0.48rem;
  }
  .area-8 .tab-desc {
    margin: 0.48rem 0 0.32rem;
  }
  .area-8 > div {
    padding: 1rem 0;
  }
  .area-8-tab .tab-item1::after {
    background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='0 0 36 36' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23FFF' stroke-width='1.4' fill='none' fill-rule='evenodd'%3E%3Cpath stroke-linecap='round' d='M6.39 5.513h25.517'/%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M15.33 30h16.746L35 28.333'/%3E%3Cpath d='M19.104 5.584v3.904'/%3E%3Cpath d='M17.645 9.38h3.976c.881 0 1.595.714 1.595 1.595v4.037a3.987 3.987 0 0 0 3.987 3.987h6.007c.66 0 1.196.535 1.196 1.196v1.97a3.166 3.166 0 0 1-3.166 3.166H20.215a4.386 4.386 0 0 1-3.973-2.528L14.463 19H8.92c-1.5 0-2.897-.767-3.702-2.033l-3.438-5.41a.797.797 0 0 1 .673-1.225h3.412c.403 0 .779.202 1 .539l1.397 2.125c.37.56.995.898 1.666.898h3.867l1.743-3.25a2.392 2.392 0 0 1 2.108-1.263z' stroke-linejoin='round'/%3E%3Cpath d='M23.193 10.804h1.994a7.97 7.97 0 0 1 7.97 7.971M21.329 25.331l-1.175 4.502M27.708 25.331l1.664 4.502'/%3E%3C/g%3E%3C/svg%3E");
  }
  .area-8-tab .tab-item1.current::after {
    background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='0 0 36 36' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23222' stroke-width='1.4' fill='none' fill-rule='evenodd'%3E%3Cpath stroke-linecap='round' d='M6.39 5.513h25.517'/%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M15.33 30h16.746L35 28.333'/%3E%3Cpath d='M19.104 5.584v3.904'/%3E%3Cpath d='M17.645 9.38h3.976c.881 0 1.595.714 1.595 1.595v4.037a3.987 3.987 0 0 0 3.987 3.987h6.007c.66 0 1.196.535 1.196 1.196v1.97a3.166 3.166 0 0 1-3.166 3.166H20.215a4.386 4.386 0 0 1-3.973-2.528L14.463 19H8.92c-1.5 0-2.897-.767-3.702-2.033l-3.438-5.41a.797.797 0 0 1 .673-1.225h3.412c.403 0 .779.202 1 .539l1.397 2.125c.37.56.995.898 1.666.898h3.867l1.743-3.25a2.392 2.392 0 0 1 2.108-1.263z' stroke-linejoin='round'/%3E%3Cpath d='M23.193 10.804h1.994a7.97 7.97 0 0 1 7.97 7.971M21.329 25.331l-1.175 4.502M27.708 25.331l1.664 4.502'/%3E%3C/g%3E%3C/svg%3E");
  }
  .area-8-tab span::after {
    content: '';
    display: block;
    position: absolute;
    width: 36px;
    height: 36px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .area-8-tab .tab-item2.current::after {
    background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='0 0 36 36' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23333' stroke-width='1.4' fill='none' fill-rule='evenodd'%3E%3Cpath d='M12.951 22.81H10.03c-.8 0-1.583-.227-2.261-.654l-5.727-3.603a1 1 0 0 1-.111-1.606l.723-.611-1.64-5.59a.332.332 0 0 1 .315-.426h3.819c.102 0 .198.048.26.13l3.3 4.35c.062.082.159.13.261.13h20.784C32.65 14.93 35 17.3 35 20.223v.265a2.31 2.31 0 0 1-2.3 2.321H20.071'/%3E%3Cpath d='M14.717 19.833l-5.239 10.21a.657.657 0 0 0 .585.957h2.967c.402 0 .781-.184 1.03-.498l8.297-10.475' stroke-linecap='round'/%3E%3Cpath d='M14.988 14.813l-4.345-7.837A.657.657 0 0 1 11.218 6h2.907c.384 0 .748.167.998.458l7.171 8.355' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E");
  }
  .area-8-tab .tab-item2::after {
    background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='0 0 36 36' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23FFF' stroke-width='1.4' fill='none' fill-rule='evenodd'%3E%3Cpath d='M12.951 22.81H10.03c-.8 0-1.583-.227-2.261-.654l-5.727-3.603a1 1 0 0 1-.111-1.606l.723-.611-1.64-5.59a.332.332 0 0 1 .315-.426h3.819c.102 0 .198.048.26.13l3.3 4.35c.062.082.159.13.261.13h20.784C32.65 14.93 35 17.3 35 20.223v.265a2.31 2.31 0 0 1-2.3 2.321H20.071'/%3E%3Cpath d='M14.717 19.833l-5.239 10.21a.657.657 0 0 0 .585.957h2.967c.402 0 .781-.184 1.03-.498l8.297-10.475' stroke-linecap='round'/%3E%3Cpath d='M14.988 14.813l-4.345-7.837A.657.657 0 0 1 11.218 6h2.907c.384 0 .748.167.998.458l7.171 8.355' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E");
  }
  /* area-9 */
  .area-9 {
    padding-bottom: 1.6rem;
  }
  .area-9-swiper-in-h5 .swiper-wrapper {
    display: block;
  }
  .area-9-mod .img-box {
    width: 5.36rem;
    margin: 0.18rem 0.48rem 0.18rem 0.16rem;
    flex: 0 0 auto;
  }
  .area-9-mod .text-box {
    width: 5.28rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .area-9-mod .text-box > div {
    margin: 0.16rem 0;
  }
  .area-9-mod li {
    color: #999;
    list-style-type: disc;
    list-style-position: inside;
  }
  .area-9-mod li span {
    color: #666;
  }
  // UI 走查修改
  .area-2 {
    :deep(.desc) {
      text-align: left;
    }
  }
</style>
